import React from "react"
import "./style.css"
import Card from "./Card.js"
import data from "./data.js"
import Navbar from "./Navbar.js"
import Particles from "./Particles"



export default function App() {
    const cards = data.map(item => {
        return (
            <Card 
            key={item.id}
            {...item}>
            </Card>
        )
    })
    return (
        <div>
            <Navbar/>
            <div className="page">
                <div className="transparent-background-box">
                <section className="cards--list">
                    {cards}
                </section>
            </div>
                </div>
            <Particles className="particle-background"/>
        </div>
    )
}